"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Minus = function Minus(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "MinusTitle MinusDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "MinusTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "MinusDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M11.155 12.996L4.846 13a.783.783 0 0 1-.598-.293 1.131 1.131 0 0 1 0-1.413.783.783 0 0 1 .598-.292h6.309l1.69-.002h6.309c.216 0 .433.098.598.293.33.39.33 1.022 0 1.413a.783.783 0 0 1-.598.292l-6.316-.009-1.683.007z",
    fillRule: "evenodd"
  }));
};

Minus.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Minus.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Minus;
exports["default"] = _default;